import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './plugins/element.js'
// 导入全局样式
import './assets/css/global.css'
import 'github-markdown-css'
import VueWechatTitle from 'vue-wechat-title' // 动态修改title

// // 引入axios
// import axios from 'axios'
// Vue.prototype.$http = axios
// axios.defaults.baseURL = 'http://www.ysqorz.top:8888/api/private/v1/'
// axios.interceptors.request.use(config => {
//   config.headers.Authorization = window.sessionStorage.getItem('token')
//   return config
// })
Vue.config.productionTip = false
// 禁止右键复制
document.onselectstart = function () { return false }

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})
Vue.use(VueWechatTitle)
new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
